export default __webpack_public_path__ + "static/hero-trainers-6d0662e386387f6a2dfd6804a9683025.jpg";